import { PersonRequest } from "@plinknz/tah-website-elements";

import { aotearoaBankConfig } from "../config-generics/bank-details";
import { personalDetailsConfig } from "../config-generics/personal-details";
import { SurveyConfig } from "../../../components/content-blocks/forms/customer-form-types";
import { introConfig } from "./intro";
import { confirmationConfig } from "./confirmation";
import { groupConfig } from "./group";
import { detailsConfig } from "./details";
import { projectPlanConfig } from "./project-plan";
import { budgetConfig } from "./budget";
import { eligibilityConfig } from "./eligibility";
import { supportLetterConfig } from "./support-letter";
import { collapseQuestions } from "../config-generics/collapseQuestions";

export const createSurveyConfig = (member: PersonRequest): SurveyConfig => {
  const personalConfig = personalDetailsConfig(member);

  return {
    pages: [
      ...introConfig,
      collapseQuestions({
        pages: [...personalConfig, ...groupConfig, ...detailsConfig],
        name: "participantDetails",
        title: "Participant Details - Taipitopito Tāngata",
      }),
      collapseQuestions({
        pages: [
          ...projectPlanConfig,
          ...budgetConfig,
          ...eligibilityConfig,
          ...aotearoaBankConfig,
          ...supportLetterConfig,
        ],
        name: "kaupapaDetails",
        title: "Project Plan - Mahere Kaupapa",
      }),
      ...confirmationConfig,
    ],
    completedHtml: `
      <h3>Tino Pai - Thank you for your application</h3>
      <p>
        The application has now been received by our office and will go through
        our review process. The Rūnanga will contact you shortly after, with the
        outcome.
      </p>
      <p>
        If you have any queries, please do not hesitate to contact the office
        via <a href="mailto:admin@rangitane.org.nz" target="_blank">
          admin@rangitane.org.nz
        </a>
      </p>
      `,
  };
};
